const getters = {
  products(state) {
    return state.products;
  },
};

export default getters;
